export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  tags: string[];
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: Chapter[];
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export interface Chapter {
  id: number;
  title: string;
  pages: string[];
  updatedAt: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20anime%20style%20cover%20art%20featuring%20a%20young%20swordsman%20with%20dark%20red%20hair%20and%20green%20checkered%20haori%20coat%2C%20holding%20a%20katana%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%2C%20clean%20illustration%20style%20with%20soft%20gradient%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '日漫',
    tags: ['热血', '战斗', '奇幻'],
    description: '时值日本大正时期。传说太阳下山后，有恶鬼出没吃人。亦有猎鬼人斩杀恶鬼、保护人们。卖炭的少年灶门炭治郎，他那平凡而幸福的日常生活，在家人遭到恶鬼袭击的那一天发生了剧变。',
    status: '已完结',
    rating: 9.7,
    views: 2580000,
    chapters: [
      { id: 1, title: '第1话 残酷', pages: [], updatedAt: '2024-01-15' },
      { id: 2, title: '第2话 育手', pages: [], updatedAt: '2024-01-22' },
    ],
    updatedAt: '2024-03-20',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 2,
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20manga%20cover%20featuring%20a%20family%20of%20three%20in%20elegant%20formal%20wear%2C%20a%20gentleman%20in%20suit%2C%20a%20lady%20in%20red%20dress%2C%20and%20a%20cute%20little%20girl%20with%20pink%20hair%2C%20clean%20modern%20anime%20art%20style%2C%20soft%20pastel%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '日漫',
    tags: ['搞笑', '日常', '温情'],
    description: '为了潜入名校，西国能力最强的间谍<黄昏>被下令组建家庭。但是，他的"女儿"居然是能够读取他人内心的超能力者！"妻子"是暗杀者？互相隐藏了真实身份的新家庭，面临考验与世界危机的痛快家庭喜剧就此展开！',
    status: '连载中',
    rating: 9.5,
    views: 1890000,
    chapters: [
      { id: 1, title: '第1话 MISSION:1', pages: [], updatedAt: '2024-02-01' },
      { id: 2, title: '第2话 MISSION:2', pages: [], updatedAt: '2024-02-08' },
    ],
    updatedAt: '2024-03-19',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20featuring%20a%20powerful%20dark%20haired%20hunter%20with%20glowing%20blue%20eyes%2C%20wearing%20black%20combat%20armor%2C%20surrounded%20by%20shadow%20soldiers%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20clean%20digital%20illustration&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '韩漫',
    tags: ['热血', '奇幻', '升级'],
    description: '10年前，世界与其他次元链接的"门"被打开，由此诞生了名为"猎人"的职业。被称为"人类最弱兵器"的E级猎人程肖宇，在一次隐藏副本中濒死之际，获得了神秘系统的力量，开启了成为最强猎人的逆袭之路。',
    status: '连载中',
    rating: 9.8,
    views: 3200000,
    chapters: [
      { id: 1, title: '第1话 最弱的猎人', pages: [], updatedAt: '2024-03-01' },
      { id: 2, title: '第2话 隐藏副本', pages: [], updatedAt: '2024-03-03' },
    ],
    updatedAt: '2024-03-21',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 4,
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=Dynamic%20manga%20cover%20featuring%20a%20teenage%20boy%20with%20spiky%20pink%20hair%2C%20martial%20arts%20uniform%2C%20surrounded%20by%20cursed%20energy%20effects%20in%20dark%20purple%20and%20blue%2C%20intense%20action%20pose%2C%20modern%20shonen%20manga%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '日漫',
    tags: ['热血', '战斗', '超自然'],
    description: '少年虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此与宿傩合为一体。在最强咒术师五条悟的引导下，虎杖进入了东京都立咒术高等专门学校，为了拔除诅咒而战的黑暗奇幻故事就此展开！',
    status: '连载中',
    rating: 9.4,
    views: 2100000,
    chapters: [
      { id: 1, title: '第1话 两面宿傩', pages: [], updatedAt: '2024-02-15' },
      { id: 2, title: '第2话 咒术师', pages: [], updatedAt: '2024-02-22' },
    ],
    updatedAt: '2024-03-18',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 5,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20cover%20featuring%20a%20young%20man%20with%20tied%20hair%20in%20traditional%20Chinese%20clothing%2C%20wielding%20martial%20arts%20stance%2C%20surrounded%20by%20mystical%20energy%2C%20ink%20wash%20painting%20elements%2C%20modern%20Chinese%20comic%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '国漫',
    tags: ['热血', '奇幻', '武侠'],
    description: '普通大学生张楚岚，因爷爷尸体离奇失踪，被迫卷入了异人世界的纷争。在这个隐藏于现代社会的异能者世界中，他逐渐揭开了自己身世的秘密，也踏上了成为最强异人的道路。',
    status: '连载中',
    rating: 9.3,
    views: 1560000,
    chapters: [
      { id: 1, title: '第1话 异人', pages: [], updatedAt: '2024-01-20' },
      { id: 2, title: '第2话 金光咒', pages: [], updatedAt: '2024-01-27' },
    ],
    updatedAt: '2024-03-17',
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 6,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20featuring%20a%20beautiful%20young%20woman%20with%20long%20brown%20hair%2C%20elegant%20makeup%2C%20stylish%20casual%20outfit%2C%20soft%20romantic%20atmosphere%2C%20pastel%20pink%20and%20warm%20tone%20background%2C%20clean%20digital%20art&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '韩漫',
    tags: ['恋爱', '校园', '美妆'],
    description: '因为外貌而被欺负的任朱静，通过化妆彻底改变了自己的人生。转学后她成为了众人眼中的"女神"，但素颜的秘密随时可能被发现。一场关于美丽、自信与真爱的校园浪漫故事。',
    status: '已完结',
    rating: 9.1,
    views: 1950000,
    chapters: [
      { id: 1, title: '第1话 化妆的力量', pages: [], updatedAt: '2024-01-10' },
      { id: 2, title: '第2话 转学', pages: [], updatedAt: '2024-01-17' },
    ],
    updatedAt: '2024-03-15',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 7,
    title: '链锯人',
    author: '藤本树',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20manga%20cover%20featuring%20a%20blond%20young%20man%20with%20chainsaw%20arms%20and%20head%2C%20wearing%20a%20white%20shirt%20and%20tie%2C%20urban%20background%20with%20splashes%20of%20red%2C%20gritty%20punk%20art%20style%2C%20dynamic%20composition&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '日漫',
    tags: ['黑暗', '战斗', '奇幻'],
    description: '贫困少年淀治为了偿还亡父的债务，与电锯恶魔波奇塔一起以恶魔猎人的身份工作。在一次任务中被杀后，波奇塔与他合体，淀治获得了变身为"链锯人"的能力，由此被公安对魔特异4课收编。',
    status: '连载中',
    rating: 9.2,
    views: 1780000,
    chapters: [
      { id: 1, title: '第1话 狗与链锯', pages: [], updatedAt: '2024-02-10' },
      { id: 2, title: '第2话 去东京', pages: [], updatedAt: '2024-02-17' },
    ],
    updatedAt: '2024-03-16',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 8,
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20featuring%20a%20confident%20gamer%20young%20man%20with%20silver%20hair%2C%20holding%20a%20gaming%20mouse%2C%20digital%20game%20interface%20elements%20in%20background%2C%20esports%20theme%2C%20modern%20vibrant%20Chinese%20comic%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '国漫',
    tags: ['电竞', '热血', '竞技'],
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐。离开职业圈的他寄身于一家网吧成了一个小小的网管，但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆和一把未完成的自制武器，开始了重返巅峰之路。',
    status: '连载中',
    rating: 9.6,
    views: 2100000,
    chapters: [
      { id: 1, title: '第1话 被驱逐的高手', pages: [], updatedAt: '2024-02-20' },
      { id: 2, title: '第2话 第十区', pages: [], updatedAt: '2024-02-27' },
    ],
    updatedAt: '2024-03-14',
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 9,
    title: '进击的巨人',
    author: '谏山创',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20manga%20cover%20featuring%20soldiers%20in%20military%20uniform%20with%20omni%20directional%20mobility%20gear%2C%20flying%20through%20a%20city%2C%20giant%20titan%20in%20background%2C%20dramatic%20cinematic%20composition%2C%20dark%20atmospheric%20tone&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '日漫',
    tags: ['黑暗', '战斗', '悬疑'],
    description: '107年前，世界上突然出现了人类的天敌"巨人"。面临着生存危机而残存下来的人类逃到了一个地方，盖起了三重巨大的城墙。人们在这隔绝的环境里享受了一百多年的和平，直到艾伦·耶格尔十岁那年，60米高的"超大型巨人"突然出现，以压倒性的力量破坏城门。',
    status: '已完结',
    rating: 9.9,
    views: 3800000,
    chapters: [
      { id: 1, title: '第1话 致两千年后的你', pages: [], updatedAt: '2024-01-05' },
      { id: 2, title: '第2话 那一天', pages: [], updatedAt: '2024-01-12' },
    ],
    updatedAt: '2024-03-10',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 10,
    title: '排球少年!!',
    author: '古馆春一',
    cover: 'https://readdy.ai/api/search-image?query=Sports%20manga%20cover%20featuring%20a%20short%20orange%20haired%20boy%20jumping%20high%20for%20volleyball%20spike%2C%20wearing%20black%20and%20orange%20volleyball%20uniform%2C%20dynamic%20sports%20action%2C%20bright%20energetic%20art%20style%2C%20gymnasium%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '日漫',
    tags: ['运动', '热血', '青春'],
    description: '小时候因为电视上看到的"小巨人"而迷上排球的少年日向翔阳，终于在初中拥有了自己的排球部。然而第一次也是最后一次正式比赛却惨败给了天才选手影山飞雄。升入高中后，他来到了曾经"小巨人"所在的乌野高中，却发现影山也选择了同一所学校。',
    status: '已完结',
    rating: 9.5,
    views: 1650000,
    chapters: [
      { id: 1, title: '第1话 结束与开始', pages: [], updatedAt: '2024-01-18' },
      { id: 2, title: '第2话 乌野高中排球部', pages: [], updatedAt: '2024-01-25' },
    ],
    updatedAt: '2024-03-12',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 11,
    title: '外貌至上主义',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20featuring%20a%20handsome%20tall%20man%20in%20school%20uniform%2C%20contrasting%20with%20a%20shadow%20of%20an%20overweight%20figure%2C%20dramatic%20school%20hallway%20background%2C%20modern%20clean%20Korean%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '韩漫',
    tags: ['校园', '励志', '剧情'],
    description: '因为肥胖的外貌而在学校备受欺凌的朴亨锡，某天醒来发现自己拥有了完美的外貌和身材。更神奇的是，他的意识可以在两个身体之间切换。以全新的身份进入校园后，他开始了一段充满挑战与成长的旅程。',
    status: '连载中',
    rating: 9.0,
    views: 1420000,
    chapters: [
      { id: 1, title: '第1话 两个身体', pages: [], updatedAt: '2024-02-05' },
      { id: 2, title: '第2话 新人生', pages: [], updatedAt: '2024-02-12' },
    ],
    updatedAt: '2024-03-13',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 12,
    title: 'JOJO的奇妙冒险',
    author: '荒木飞吕彦',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20in%20distinctive%20JoJo%20art%20style%20featuring%20a%20muscular%20character%20in%20flamboyant%20pose%2C%20colorful%20fashion%20outfit%2C%20stand%20power%20silhouette%20behind%2C%20bold%20vibrant%20colors%2C%20dramatic%20lighting%2C%20iconic%20shonen%20manga%20aesthetic&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '日漫',
    tags: ['奇幻', '战斗', '冒险'],
    description: '这是一个关于乔斯达家族跨越数代人与迪奥及其追随者之间斗争的故事。从19世纪的英国，到现代的日本，再到世界各地的冒险。每代主角都拥有名为"替身"的超能力，展开一场又一场精彩的智斗与力斗。',
    status: '连载中',
    rating: 9.6,
    views: 2300000,
    chapters: [
      { id: 1, title: '第1话 侵略者迪奥', pages: [], updatedAt: '2024-01-30' },
      { id: 2, title: '第2话 石鬼面', pages: [], updatedAt: '2024-02-06' },
    ],
    updatedAt: '2024-03-11',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
];

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: '日漫', name: '日漫', icon: 'ri-sun-line' },
  { slug: '韩漫', name: '韩漫', icon: 'ri-moon-line' },
  { slug: '国漫', name: '国漫', icon: 'ri-star-line' },
  { slug: '热血', name: '热血', icon: 'ri-fire-line' },
  { slug: '恋爱', name: '恋爱', icon: 'ri-heart-line' },
  { slug: '搞笑', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: '奇幻', name: '奇幻', icon: 'ri-magic-line' },
  { slug: '悬疑', name: '悬疑', icon: 'ri-search-eye-line' },
];

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter(
    (c) => c.category === slug || c.tags.includes(slug)
  );
}

export function getHotComics(): Comic[] {
  return comics.filter((c) => c.isHot);
}

export function getNewComics(): Comic[] {
  return comics.filter((c) => c.isNew);
}

export function getRecommendedComics(): Comic[] {
  return comics.filter((c) => c.isRecommended);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}